var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_cof.js
// module id = 37
// module chunks = 0